import { sharedCookieDomain } from "campaign-builder/sharedCookieDomain";
import { toCopilotCookieDomain } from "./conversationApi.mjs";

/**
 * Domain for the @oppizi-ecosystem/copilot cookies (`copilot_panel_open`,
 * `copilot_conversation`): 'oppizi.com' on oppizi.com and every *.oppizi.com
 * host so the open state and the selected conversation survive the
 * builder ↔ platform-next hop; undefined (host-only) anywhere else. Same
 * source of truth as the theme / sidebar cookies (sharedCookieDomain), mapped
 * to what the library expects (see conversationApi.mjs).
 *
 * @returns {string | undefined}
 */
export const copilotCookieDomain = () => toCopilotCookieDomain(sharedCookieDomain());
